import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { 
    DropBoxContainer,
    StyledFormControl,
 } from './SaveAsDropBox.styles';

export default function SaveAsDropBox() {
  const [save, setSave] = React.useState('');

  const handleChange = (event) => {
    setSave(event.target.value);
  };

  return (
    <DropBoxContainer>
      <StyledFormControl fullWidth>
        <InputLabel id="save-as-label">Save As</InputLabel>
        <Select
            labelId="save-as-label"
            id="save-as"
            value={save}
            label="Save As"
            onChange={handleChange}
        >
            <MenuItem value="docx">Word Document (.docx)</MenuItem>
        </Select>
        </StyledFormControl>
    </DropBoxContainer>
  );
}

/*
 *   <MenuItem value="pdf">Adobe (.pdf)</MenuItem>
 *   <MenuItem value="xlsx">Excel Spreadsheet (.xlsx)</MenuItem>
 *   <MenuItem value="csv">Comma Separated Values (.csv)</MenuItem> 
*/